import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { ChannelsService } from '../../../services/channels.service';
import { ProvidersService } from '../../../services/providers.service';
import { AlertService } from '../../../services/alert.service';
import { PROFILES } from '../../../constants';
import { useSession } from '../../../hooks/use-session.hook';
import { Controller } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import Header from '../../../components/layout/header.component';
import Asaid from '../../../components/layout/asaid.component';
import Footer from '../../../components/layout/footer.component';
import useBgPages from '../../../hooks/use-bg-pages.hook';
import OutputsModal from './modal/outputs.modal';
import Datatable from '../../../components/datatable/datatable.component';
import useRequest from '../../../hooks/use-request.hook';
import AgentsModal from './modal/agents.modal';
import Icon from '../../../components/forms/icon.component';
import ActionsDropdown from '../../../components/datatable/actions-dropdown.component';
import SendMessageModalRCS from './modal/send.message.modal';
import PrincipalCard from '../../../components/cards/principal-card.component';
import LogData from '../../../components/logs/log-data.component';
import Select from 'react-select';
interface Data {
  _id: string;
  created_at: string;
  is_international: boolean;
  updated_at: string;
  status: boolean;
  provider: string;
  telcel: Array<{ rcs_agent: string; priority: number }>;
  movistar: Array<{ rcs_agent: string; priority: number }>;
  att: Array<{ rcs_agent: string; priority: number }>;
  other: Array<{ rcs_agent: string; priority: number }>;
  name: string;
  carriers: Array<string>;
  settings: Array<string>;
}

function ChannelRCSPage() {
  useBgPages();
  const { t } = useTranslation();
  const { session, selectedAccount } = useSession();
  const { call, isRequesting } = useRequest();
  const [totalRegistersAgents, setTotalRegistersAgents] = useState<number>(0);
  const [totalAgents, setTotalActivesAgents] = useState<number>(0);
  const [totalInternational, setTotalInternational] = useState<number>(0);
  const [totalRegistersChannels, setTotalRegistersChannels] = useState<number>(0);
  const [totalChannels, setTotalActivesChannels] = useState<number>(0);
  const [providers, setProviders] = useState<any[]>([]);
  const [agents, setAgents] = useState<Data[]>([]);
  const [agentsChannel, setAgentsChannel] = useState<{ [key: string]: Array<any> }>({});
  const [channels, setChannels] = useState<Data[]>([]);
  const [activeTab, setActiveTab] = useState(
    session.profile === PROFILES.ADMIN ? 'tabTwo' : 'tabOne'
  );

  const [showModalAgent, setShowModalAgent] = useState({
    show: false,
    data: null
  });
  const [showModalOutputs, setShowModalOutputs] = useState({
    show: false,
    data: null
  });
  const [showModalSendMessage, setShowModalSendMessage] = useState({
    show: false,
    data: null
  });

  const { control, watch } = useForm({
    mode: 'onChange',
    defaultValues: {
      rcsType: 'rcs_basic'
    }
  });

  const dataStatisticsOutputs = [
    {
      label: t('channels.rcs.registers'),
      total: totalRegistersChannels,
      type: '',
      icon: 'ki-book-open'
    },
    {
      label: t('channels.rcs.actives'),
      total: totalChannels,
      type: 'primary',
      icon: 'ki-check-circle'
    },
    {
      label: t('channels.rcs.international'),
      total: totalInternational,
      type: 'info',
      icon: 'ki-abstract-39'
    }
  ];

  const dataStatisticsAgents = [
    {
      label: t('channels.rcs.registers'),
      total: totalRegistersAgents,
      type: '',
      icon: 'ki-book-open'
    },
    {
      label: t('channels.rcs.actives'),
      total: totalAgents,
      type: 'primary',
      icon: 'ki-check-circle'
    }
  ];

  const tabsRCS =
    session.profile === PROFILES.ADMIN
      ? [{ key: 'tabTwo', label: t('channels.rcs.agents.tab') }]
      : [
          { key: 'tabOne', label: t('channels.rcs.outputs') },
          { key: 'tabTwo', label: t('channels.rcs.agents.tab') }
        ];

  const rcsOptions = [
    { value: 'rcs_basic', label: t('channels.rcs.basic') },
    { value: 'rcs_single', label: t('channels.rcs.single') },
    { value: 'rcs_conversational', label: t('channels.rcs.conversational') }
  ];

  const operators = [
    {
      name: 'telcel',
      img: '/assets/media/operators/telcel.png',
      imgDark: '/assets/media/operators/telcel-dark.png',
      width: '60px',
      height: '15px'
    },
    {
      name: 'movistar',
      img: '/assets/media/operators/movistar.png',
      imgDark: '/assets/media/operators/movistar-dark.png',
      width: '60em',
      height: '15px'
    },
    {
      name: 'att',
      img: '/assets/media/operators/att.png',
      imgDark: '/assets/media/operators/att-dark.png',
      width: '55em',
      height: '22px'
    },
    {
      name: 'altan',
      img: '/assets/media/operators/altan.png',
      imgDark: '/assets/media/operators/altan-dark.png',
      width: '50em',
      height: '22px'
    }
  ];

  const columnsAgents = [
    {
      name: t('channels.rcs.agent-tc-1'),
      sortable: true,
      selector: (r: any) => `${r.name} ${r.is_international} ${r.type}`,
      width: 25,
      cell: (agents: any) => {
        let internationalLabel = t('general.no-info');

        if (agents.is_international === true) {
          internationalLabel = t('channels.rcs.international');
        } else if (agents.is_international === false) {
          internationalLabel = t('channels.rcs.nacional');
        }

        return (
          <div className="text-nowrap fs-5">
            <p className="m-0">
              <strong>{t('channels.rcs.tc-name')}:</strong> {agents.name || t('general.no-info')}
            </p>
            <p className="mb-0">
              <strong>{t('general.type')}:</strong>{' '}
              {agents.type ? t(`channels.rcs.${agents.type.toLowerCase()}`) : t('general.no-info')}
            </p>
            <p className="mb-0">
              <strong>{internationalLabel}</strong>
            </p>
          </div>
        );
      }
    },
    {
      name: t('channels.rcs.outputs'),
      sortable: true,
      selector: (r: any) => `${r.att} ${r.movistar} ${r.telcel} ${r.other}`,
      width: 20,
      cell: (row: any) => {
        const renderLine = (label: string, count: number) =>
          count > 0 && (
            <div className="mb-1">
              <strong>{label}:</strong>{' '}
              <span className="ms-1">
                {t('channels.rcs.outputs')} {count}
              </span>
            </div>
          );
        const getCount = (key: string) => (Array.isArray(row[key]) ? row[key].length : 0);
        const outputData = [
          { label: 'Telcel', key: 'telcel' },
          { label: 'Movistar', key: 'movistar' },
          { label: 'ATT', key: 'att' },
          {
            label: row.is_international ? t('channels.rcs.international') : 'Otros',
            key: row.is_international ? 'international' : 'other'
          }
        ];
        return (
          <div className="d-flex flex-column fs-5 text-nowrap">
            {outputData.map(({ label, key }) => renderLine(label, getCount(key)))}
          </div>
        );
      }
    },
    {
      name: t('channels.rcs.agent-tc-3'),
      sortable: true,
      selector: (r: any) => `${r._id}`,
      width: 10,
      cell: (agents: any) => {
        return (
          <div className="d-flex justify-content-start align-items-center pb-5 px-0 overflow-auto">
            <ul className="nav nav-pills nav-pills-custom mb-3 d-flex flex-nowrap">
              {operators.map((operator) => {
                const isActive =
                  (Array.isArray(agents[operator.name]) && agents[operator.name].length > 0) ||
                  (operator.name === 'altan' &&
                    ((agents.is_international &&
                      Array.isArray(agents.international) &&
                      agents.international.length > 0) ||
                      (!agents.is_international &&
                        Array.isArray(agents.other) &&
                        agents.other.length > 0)));
                return (
                  <li className="nav-item mb-3 me-3 me-lg-3" key={operator.name}>
                    <span
                      className="nav-link btn btn-outline btn-flex btn-active-color-primary flex-column overflow-hidden w-70px h-50px pt-3 pb-2 active"
                      data-bs-toggle="pill"
                      id={`kt_charts_widget_10_tab_${operator.name}`}
                    >
                      <div className="mb-3">
                        <span className="theme-light-show">
                          <img
                            title="img"
                            alt="operator"
                            src={operator.img}
                            width={operator.width}
                            height={operator.height}
                          />
                        </span>
                        <span className="theme-dark-show">
                          <img
                            title="img"
                            alt="operator"
                            src={operator.imgDark}
                            width={operator.width}
                            height={operator.height}
                          />
                        </span>
                      </div>
                      <span
                        className={`bullet-custom position-absolute bottom-0 w-100 h-4px ${isActive ? 'bg-primary' : 'bg-danger'}`}
                      />
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      }
    },
    {
      name: t('roles.title-column-3'),
      sortable: true,
      selector: (r: any) => `${r.status}`,
      width: 13,
      cell: (row: any) =>
        row.status ? (
          <span className="badge text-dark fs-5">
            <Icon icon="ki-check-circle" size="fs-3" type="primary" />
            {t('general.active')}
          </span>
        ) : (
          <span className="badge text-dark fs-5">
            <Icon icon="ki-minus-circle" size="fs-3" type="danger" />
            {t('general.inactive')}
          </span>
        )
    },
    ...(session.profile === PROFILES.ROOT
      ? [
          {
            name: t('general.acctions'),
            sortable: true,
            selector: (r: any) => `${r._id}`,
            exportable: false,
            width: 20,
            cell: (agents: any) => (
              <ActionsDropdown
                edit={() => setShowModalAgent({ show: true, data: agents })}
                changeStatus={() =>
                  changeAgentStatus(agents._id, 'changeStatusAgents-8383777722', agents.status)
                }
                rowStatus={agents.status}
              />
            )
          }
        ]
      : [])
  ];

  const columnsChannels = [
    {
      name: t('channels.rcs.channel-tc-1'),
      sortable: true,
      selector: (r: any) => `${r.name} ${r.is_international} ${r.type}`,
      width: 25,
      cell: (rows: any) => {
        const internationalEmpty = !rows.is_international && rows.is_international !== false;

        let internationalLabel = t('general.no-info');

        if (!internationalEmpty) {
          if (rows.is_international) {
            internationalLabel = t('channels.rcs.international');
          } else {
            internationalLabel = t('channels.rcs.nacional');
          }
        }

        return (
          <div className="text-nowrap fs-5">
            <p className="m-0">
              <strong>{t('channels.rcs.tc-name')}:</strong> {rows.name || t('general.no-info')}
            </p>
            <p className="mb-0">
              <strong>{t('general.type')}:</strong>{' '}
              {Array.isArray(rows.type) && rows.type.length > 0
                ? rows.type
                    .map((item: string) => t(`channels.rcs.${item.toLowerCase()}`))
                    .join(', ')
                : t('general.no-info')}
            </p>
            <p className="mb-0">
              <strong>{internationalLabel}</strong>
            </p>
          </div>
        );
      }
    },
    {
      name: t('channels.rcs.agent-tc-2'),
      sortable: true,
      selector: (r: any) => `${r.provider.name}`,
      width: 15,
      cell: (rows: any) => {
        if (!rows.provider) return null;
        return (
          <div className="d-flex align-items-center fs-5">
            <span className="ms-2 fs-6">
              <strong>{rows.provider.name}</strong>
            </span>
          </div>
        );
      }
    },
    {
      name: t('channels.rcs.agent-tc-3'),
      sortable: true,
      selector: (r: any) => `${r.operators}`,
      width: 30,
      cell: (agents: any) => {
        if (!agents.operators || !Array.isArray(agents.operators)) return null;

        return (
          <div className="d-flex justify-content-start align-items-center pb-5 px-0 overflow-auto">
            <ul className="nav nav-pills nav-pills-custom mb-3 d-flex flex-nowrap">
              {operators.map((operator) => {
                const isActive =
                  agents.operators?.includes(operator.name) ||
                  (operator.name === 'altan' && agents.operators?.includes('other'));
                return (
                  <li className="nav-item mb-3 me-3 me-lg-3" key={operator.name}>
                    <div
                      className="nav-link pe-none cursor-default btn btn-outline btn-flex btn-active-color-primary flex-column overflow-hidden w-70px h-50px pt-3 pb-2 active"
                      data-bs-toggle="pill"
                      id={`kt_charts_widget_10_tab_${operator.name}`}
                    >
                      <div className="mb-3">
                        <span className="theme-light-show">
                          <img
                            title="img"
                            alt="operator"
                            src={operator.img}
                            width={operator.width}
                            height={operator.height}
                          />
                        </span>
                        <span className="theme-dark-show">
                          <img
                            title="img"
                            alt="operator"
                            src={operator.imgDark}
                            width={operator.width}
                            height={operator.height}
                          />
                        </span>
                      </div>
                      <span
                        className={`bullet-custom position-absolute bottom-0 w-100 h-4px ${isActive ? 'bg-primary' : 'bg-danger'}`}
                      />
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      }
    },
    {
      name: t('roles.title-column-3'),
      sortable: true,
      selector: (r: any) => `${r.status}`,
      width: 13,
      cell: (row: any) =>
        row.status ? (
          <span className="badge text-dark fs-5">
            <Icon icon="ki-check-circle" size="fs-3" type="primary" />
            {t('general.active')}
          </span>
        ) : (
          <span className="badge text-dark fs-5">
            <Icon icon="ki-minus-circle" size="fs-3" type="danger" />
            {t('general.inactive')}
          </span>
        )
    },
    {
      name: t('general.acctions'),
      sortable: true,
      selector: (r: any) => `${r._id}`,
      exportable: false,
      cell: (rows: any) => {
        const options =
          rows.status !== false
            ? [
                {
                  label: t('channels.rcs.send-message-text'),
                  icon: 'ki-send',
                  color: 'primary',
                  onClick: () => setShowModalSendMessage({ show: true, data: rows })
                }
              ]
            : [];

        return (
          <ActionsDropdown
            edit={() => setShowModalOutputs({ show: true, data: rows })}
            changeStatus={() =>
              changeOutputStatus(rows._id, 'changeStatus-7394734567', rows.status)
            }
            rowStatus={rows.status}
            options={options}
          />
        );
      }
    }
  ];

  const getChannels = async () => {
    try {
      const response = await call(() => ChannelsService.getOutputsRCS());
      const channelsData: Data[] = response;
      setTotalActivesChannels(channelsData.filter((channel) => channel.status === true).length);
      setTotalInternational(
        channelsData.filter((channel) => channel.is_international === true).length
      );
      setTotalRegistersChannels(channelsData.length);
      setChannels(channelsData);
    } catch (errorCode: any) {
      console.log('Error:', errorCode);
      AlertService.toastError(errorCode.error || errorCode);
    }
  };

  const getOutputsCatalogue = async () => {
    try {
      const data: any = await call(() => ChannelsService.getOutputsRCS());
      const catalogue: { [key: string]: Array<any> } = {};

      data.forEach((item: any) => {
        if (!item.status) return;

        const { _id, name, operators, is_international } = item;

        if (Array.isArray(operators) && operators.length > 0) {
          operators.forEach((provider: string) => {
            if (!catalogue[provider]) {
              catalogue[provider] = [];
            }
            catalogue[provider].push({ _id, name, is_international });
          });
        }

        if (is_international && (!Array.isArray(operators) || operators.length === 0)) {
          if (!catalogue['other']) {
            catalogue['other'] = [];
          }
          catalogue['other'].push({ _id, name, is_international });
        }
      });

      setAgentsChannel(catalogue);
    } catch (errorCode: any) {
      console.log('Error:', errorCode);
      AlertService.toastError(errorCode.error || errorCode);
    }
  };

  const getAgents = async () => {
    try {
      let response = [];
      if (session.profile === PROFILES.ROOT) {
        response = await call(() => ChannelsService.getAgentsRCS());
        const agentsData: Data[] = response;
        setTotalActivesAgents(agentsData.filter((channel) => channel.status === true).length);
        setTotalRegistersAgents(agentsData.length);
        setAgents(agentsData);
      } else if (session.profile === PROFILES.ADMIN) {
        response = await call(() =>
          ChannelsService.getAgentsRCSForAccount(selectedAccount.account_id, watch('rcsType'))
        );
        const agentsData: Data[] = response;
        setTotalActivesAgents(agentsData.filter((channel) => channel.status === true).length);
        setTotalRegistersAgents(agentsData.length);
        setAgents(agentsData);
      }
    } catch (errorCode: any) {
      console.log('Error:', errorCode);
      AlertService.toastError(errorCode.error || errorCode);
    }
  };

  const getProviders = async () => {
    try {
      const data = await ProvidersService.getProvidersRCS();
      setProviders(
        data.map((item: any) => ({
          value: item._id,
          label: item.name,
          type: item.type,
          settings: item.settings_definition
        }))
      );
    } catch (errorCode: any) {
      console.log('Error:', errorCode);
      AlertService.toastError(errorCode.error || errorCode);
    }
  };

  const changeOutputStatus = async (id: string, buttonId: string, status: boolean) => {
    const messageQuestion = status
      ? '¿Deseas desactivar esta salida?'
      : '¿Deseas activar esta salida?';

    const isConfirmed = await AlertService.question(
      t('general.atention'),
      messageQuestion + '<br><br>',
      () => Promise.resolve(true)
    );
    if (!isConfirmed) return;

    status = !status;
    try {
      await call(() => ChannelsService.changeOutputStatus({ id, status }));
      AlertService.toastSuccess('¡ Éxito !, se cambio el status de tu salida correctamente');
      await getChannels();
      await getOutputsCatalogue();
      LogData({ id: id, status: status ? 'enable' : 'disable' }, buttonId, window.location.href);
    } catch (errorCode: any) {
      console.log('Error:', errorCode);
      AlertService.toastError(errorCode.error || errorCode);
    }
  };

  const changeAgentStatus = async (id: string, buttonId: string, status: boolean) => {
    const messageQuestion = status
      ? '¿Deseas desactivar esta máscara?'
      : '¿Deseas activar esta máscara?';
    const isConfirmed = await AlertService.question(
      t('general.atention'),
      messageQuestion + '<br><br>',
      () => Promise.resolve(true)
    );
    if (!isConfirmed) return;

    status = !status;
    try {
      await call(() => ChannelsService.changeStatusAgents({ id: id, active: status }));
      AlertService.toastSuccess('¡ Éxito !, se cambio el status de tu agente correctamente');
      await getAgents();
      await getOutputsCatalogue();
      LogData({ id: id, status: status ? 'enable' : 'disable' }, buttonId, window.location.href);
    } catch (errorCode: any) {
      console.log('Error:', errorCode);
      AlertService.toastError(errorCode.error || errorCode);
    }
  };

  const handleShowModalAgent = async (refresh: boolean) => {
    if (refresh) {
      await getAgents();
    }
    setShowModalAgent({ show: false, data: null });
  };

  const handleShowModalChannel = async (refresh: boolean) => {
    if (refresh) {
      await getChannels();
      await getOutputsCatalogue();
    }
    setShowModalOutputs({ show: false, data: null });
  };

  const handleShowModalSendMessage = async (refresh: boolean) => {
    if (refresh) {
      await getChannels();
    }
    setShowModalSendMessage({ show: false, data: null });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getOutputsCatalogue();
        await getProviders();
        await getChannels();
        await getAgents();
      } catch (error: any) {
        AlertService.toastError(t('general.atention'), error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    getAgents();
  }, [watch('rcsType')]);

  return (
    <>
      <div className="page d-flex flex-row flex-column-fluid">
        <Asaid />
        <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
          <Header />
          <div className="content fs-4 d-flex flex-column flex-column-fluid" id="kt_content">
            <div className="post fs-4 d-flex flex-column-fluid" id="kt_post">
              <div className="container-xxl">
                <PrincipalCard
                  dataStatistics={
                    activeTab === 'tabOne' ? dataStatisticsOutputs : dataStatisticsAgents
                  }
                  btnCreate={session.profile === PROFILES.ROOT}
                  btnRefresh
                  onRefresh={async () => {
                    if (activeTab === 'tabOne') {
                      await getOutputsCatalogue();
                    } else {
                      await getAgents();
                    }
                    AlertService.toastSuccess('¡Éxito! Información actualizada.');
                  }}
                  onClick={
                    activeTab === 'tabOne'
                      ? () => setShowModalOutputs({ show: true, data: null })
                      : () => setShowModalAgent({ show: true, data: null })
                  }
                  btnBack
                  title={activeTab === 'tabOne' ? 'Salidas' : 'Agentes'}
                  titleBolder="RCS"
                  subtitle={`Configura y gestiona tus ${activeTab === 'tabOne' ? 'salidas' : 'agentes'}.`}
                  breadcrumbItems={['Operaciones', 'Canales']}
                  textButton={activeTab === 'tabOne' ? 'Agregar salida' : 'Agregar agente'}
                  iconButton="ki-soft-2"
                  tabs={tabsRCS}
                  onTabChange={setActiveTab}
                />
                <div className="card mb-5 mb-xl-10">
                  <div className="card-header align-items-center border-0 mt-5 justify-content-between">
                    <div className="card-title align-items-start flex-column animate-fadeInUp animate-delay-1 h3">
                      <span className="fw-bolder fw-bold fs-2">{t('channels.rcs.list')}</span>
                      <span className="text-gray-700 mt-2 fw-semibold fs-6">
                        {activeTab === 'tabOne'
                          ? t('channels.rcs.outputs')
                          : t('channels.rcs.agents.tab')}
                      </span>
                    </div>
                    {session.profile !== PROFILES.ROOT && (
                      <div className="card-toolbar ms-auto">
                        <button
                          type="button"
                          className={`btn btn-light-dark btn-center`}
                          data-kt-menu-trigger="{default: 'hover', lg: 'hover'}"
                          data-kt-menu-attach="parent"
                          data-kt-menu-placement="bottom-end"
                        >
                          <span className="fw-bolder">Filtros</span>
                          <Icon
                            icon="ki-filter"
                            size="fs-2"
                            className="hover-scale ms-2 fw-bolder"
                          />
                        </button>
                        <div
                          className="menu menu-sub menu-sub-dropdown menu-column fw-semibold py-3 w-auto min-w-200px max-w-full text-nowrap w-350px bg-dropFilter"
                          data-kt-menu="true"
                          style={{ minWidth: '20rem' }}
                        >
                          <div className="bg-dropFilter" onClick={(e) => e.stopPropagation()}>
                            <div className="card-header card-header-content-between pb-2 pt-5">
                              <div className="fs-5 text-gray-900 fw-bolder mt-3">
                                Selecciona los filtros <br />
                                <span className="text-primary fs-7">El campo es obligatorio</span>
                              </div>
                            </div>
                            <div className="card-body">
                              <div className="mb-7">
                                <label className="form-label required">
                                  {t('general.type')}
                                  <span className="fs-8 text-muted ms-1"></span>
                                </label>
                                <div className="row">
                                  <div className="col">
                                    <Controller
                                      control={control}
                                      name={'rcsType'}
                                      render={({ field: { onChange, value } }) => (
                                        <Select
                                          options={rcsOptions}
                                          noOptionsMessage={({ inputValue }) =>
                                            inputValue
                                              ? t('general.no-options', { inputValue })
                                              : t('general.no-options')
                                          }
                                          value={
                                            rcsOptions.filter((option: any) =>
                                              value?.includes(option.value)
                                            ) || []
                                          }
                                          onChange={(selectedOption) => {
                                            const selectedValue = selectedOption?.value || '';
                                            onChange(selectedValue);
                                          }}
                                          placeholder={t('blacklist-page.company-placeholder')}
                                          className="form-select-custom"
                                          classNamePrefix="form-select-custom"
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="card-body pt-1">
                    {activeTab === 'tabOne' && (
                      <>
                        <Datatable
                          columns={columnsChannels}
                          data={channels}
                          isLoading={isRequesting}
                        />
                      </>
                    )}
                    {activeTab === 'tabTwo' && (
                      <>
                        <Datatable columns={columnsAgents} data={agents} isLoading={isRequesting} />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
      <OutputsModal
        providers={providers}
        show={showModalOutputs.show}
        payload={showModalOutputs.data}
        onRequestClose={(refresh: any) => handleShowModalChannel(refresh)}
      />
      <AgentsModal
        show={showModalAgent.show}
        provider={providers}
        payload={showModalAgent.data}
        agents={agentsChannel}
        onRequestClose={(refresh: any) => handleShowModalAgent(refresh)}
      />
      <SendMessageModalRCS
        show={showModalSendMessage.show}
        payload={showModalSendMessage.data}
        onRequestClose={(refresh: any) => handleShowModalSendMessage(refresh)}
      />
    </>
  );
}

export default ChannelRCSPage;
